import { Box } from '@mui/material';

export const CloseIconSvg = () => (
	<svg aria-hidden="true" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4b5563"
		strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
		<line x1="18" y1="6" x2="6" y2="18" />
		<line x1="6" y1="6" x2="18" y2="18" />
	</svg>
);

/**
 * Green header band with start-aligned title and circular close button.
 * RTL mirrors automatically via flex order — no isArabic() positioning.
 */
export const FsDialogHeader = ({
	title,
	subTitle = '',
	hideCloseBtn = false,
	onClose,
	className = '',
	columnClassName = '',
	titleClassName = '',
	subtitleClassName = '',
	closeClassName = '',
	children,
}) => {
	return (
		<Box className={`fs-dialog-header ${className}`}>
			<Box className={`flex flex-col items-start min-w-0 ${columnClassName}`}>
				{title ? <h2 className={`fs-dialog-title ${titleClassName}`}>{title}</h2> : null}
				{subTitle ? (
					<p className={`fs-dialog-subtitle ${subtitleClassName}`}>{subTitle}</p>
				) : null}
				{children}
			</Box>
			{!hideCloseBtn ? (
				<button
					type="button"
					aria-label="close"
					className={`fs-dialog-close ${closeClassName}`}
					onClick={() => {
						onClose && onClose(false);
					}}>
					<CloseIconSvg />
				</button>
			) : null}
		</Box>
	);
};
